import { $can } from '@/core/utils/VueAcl'
import store from '@/core/store'

export default {
  sectionName: 'LeftNavigation_ContentMenu',
  icon: 'navigation-content',
  index: '4',
  isAllowed: () =>
    $can('CampaignTemplate::Read') ||
    $can('ContentSnippet:FullAccess') ||
    $can('viewProjectItem') ||
    $can('EmailSavedRows::Read'),
  subItems: [
    {
      sectionName: 'LeftNavigation_CampaignTemplates',
      index: '4-1',
      isAllowed: () => $can('CampaignTemplate::Read'),
      routeName: 'Templates'
    },
    {
      sectionName: 'LeftNavigation_Snippets',
      index: '4-2',
      routeName: 'Snippets',
      subRouteName: [
        'SnippetsCreate',
        'SnippetsUpdate',
        'SnippetsView',
        'SnippetsCopy'
      ],
      isAllowed: () => $can('ContentSnippet:FullAccess')
    },
    {
      sectionName: 'LeftNavigation_Sites',
      index: '4-3',
      isAllowed: () => {
        return (
          store.getters.isMicrositesAvailable &&
          store.state.app.features.micrositesGlobalFlag
        )
      },
      routeName: 'Sites',
      subRouteName: ['SiteCreate', 'SiteUpdate', 'SiteView', 'SiteCopy']
    },
    {
      sectionName: 'LeftNavigation_PushCategories',
      index: '4-4',
      isAllowed: () => $can('viewProjectItem'),
      routeName: 'PushCategories'
    },
    {
      sectionName: 'LeftNavigation_EmailSavedRows',
      index: '4-5',
      isAllowed: () => $can('EmailSavedRows::Read'),
      routeName: 'EmailRowsSaved',
      subRouteName: ['EmailSavedRowsUpdate']
    }
  ]
}



// WEBPACK FOOTER //
// ./src/common/components/navigation/navigation-section-items/content.js